import * as React from "react";
import {
  ChartPie,
  DiamondPlus,
  Dna,
  Home,
  Plus,
  PlusCircle,
  Settings2,
} from "lucide-react";

import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import { TeamSwitcher } from "@/components/team-switcher";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar";
import { AuthStore } from "@/store/useAuthStore.ts";

const data = {
  teams: [
    {
      name: "Sila Green Genetics",
      logo: Dna,
      plan: "Administrators",
    },
  ],
  navMain: [
    {
      title: "Home",
      url: "/admin",
      icon: Home,
      isActive: true,
    },
    {
      title: "Analytics",
      url: "/analytics",
      icon: ChartPie,
    },
    {
      title: "owned",
      url: "/admin/admin-add-animal",
      icon: DiamondPlus,
    },
    {
      title: 'Animal',
      url: "/admin/register-farmer-animal",
      icon: PlusCircle,
    },
    {
      title: "Settings",
      url: "/settings",
      icon: Settings2,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { userInfo } = AuthStore();
  const role = userInfo.role;
  const farmerData = {
    teams: [
      {
        name: "Sila Green Genetics",
        logo: Dna,
        plan: "Administrators",
      },
    ],
    navMain: [
      {
        title: "Home",
        url: "/overview",
        icon: Home,
        isActive: true,
      },
      {
        title: "Add",
        url: "/add-animal",
        icon: Plus,
        isActive: true,
      },
    ],
  };

  return (
    <Sidebar
      collapsible="icon"
      {...props}
      className={"bg-gray-100 dark:bg-stone-950"}
    >
      <SidebarHeader className={"border-b-1 dark:border-gray-800"}>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>
      <SidebarContent>
        {role === "admin" && <NavMain items={data.navMain} />}
        {role === "Farmer" && <NavMain items={farmerData.navMain} />}
      </SidebarContent>
      <SidebarFooter className={"border-t-1  dark:border-gray-800"}>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
